import { ProductService } from 'src/app/angularJS/services/product/product.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { PermissionHelperService } from 'src/app/angularJS/services/permissionHelpers.service';

/**
* A Controller which is used to show a list of products
*/
export class ProductListController {
  public static $inject = [
    '$rootScope',
    '$state',
    '$stateParams',
    'catalogue',
    'productService',
    'PrimaryAction',
    'UserMessages',
    'permissionHelpers'
  ];
  public permissionsForProductsVariants: InterACT.Interfaces.IProductVariantPermissions;
  private permissionsForCatalogue: InterACT.Interfaces.ICataloguePermissions;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $stateParams,
    public catalogue: InterACT.Interfaces.Catalogues.Catalogue,
    public productService: ProductService,
    private primaryAction,
    private UserMessages: UserMessagesService,
    private permissionHelpers: PermissionHelperService
  ) {
    this.activate();
  }

  /**
   * A method which is used to fetch a list of products
   *
   * @param page The number of the page we wish to get
   * @param perPage The number of items we want to show per page
   */
  public fetchCollection = (page: number, perPage: number) => {
    this.$rootScope.showSpinner = true;
    return this.productService.getList(this.catalogue.id, page, perPage, {
      catalogueVersion: this.$stateParams.catalogueVersion
    }).then(() => {
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * A method which is used to take the user to the create screen
   */
  public goToCreate = () => {
    this.$state.go('productsCreate', {
      catalogueId: this.catalogue.id,
      catalogueVersion: this.catalogue.version
    });
  }

  /**
   * A method which is used to take the user to the edit screen
   */
  public goToEdit = (product: InterACT.Interfaces.Catalogues.Product) => {
    this.$state.go('productsEdit', {
      catalogueId: this.catalogue.id,
      catalogueVersion: this.catalogue.version,
      productId: product.id,
      sourceCatalogue: this.catalogue,
      sourceProduct: product
    });
  }

  /**
   * A method which is used to delete a product
   *
   * @param product The product we wish to delete
   */
  public deleteProduct = (product: InterACT.Interfaces.Catalogues.Product) => {
    return this.UserMessages.buildConfirmDialog(
      'CONFIRM_DIALOG.PRODUCT.DELETE_THIS',
      'CONFIRM_DIALOG.PRODUCT.DELETE',
      { product: product.name },
      'CONFIRM_DIALOG.PRODUCT.DELETE_CONFIRM'
    ).then(() => {
      this.productService.remove(this.catalogue.id, product.id).then(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.PRODUCT.DELETED');
      });
    });
  }

  /**
   * A method which is used to instantiate the controller
   */
  private activate() {
    this.$rootScope.showSpinner = false;
    this.findPermissionsForCatalogue();
    if (this.permissionsForCatalogue.canEdit) {
      this.primaryAction.setActions([{
        name: 'Add',
        icon: 'add',
        action: this.goToCreate
      }]);
    }
    this.fetchCollection(1, this.productService.perPageCount);
  }

  /**
   * A method which is used to find permissions for a catalogue
   */
  private findPermissionsForCatalogue = () => {
    this.permissionsForCatalogue = this.permissionHelpers.getPermissionsForCatalogue(this.catalogue);
    this.permissionsForProductsVariants = this.permissionHelpers.getPermissionsForProductsVariants(this.catalogue);
  }
}